<template>
<div>
    <form-with-data :id="id" :isEdit="isEdit" ref="form" @submitLoad="submitLoad"></form-with-data>
    <div class="button-div">
        <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
    </div>
</div>
</template>
<script>
import formWithData from './withData'
export default {
  components: { formWithData },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    submit () {
      this.$refs.form.submit()
    },
    submitLoad (val) {
      this.loading = val
    }
  }
}
</script>
<style module lang="less">

</style>
